export default "__VITE_ASSET__U1IMMOAD__"